/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation LCRRoutePlanUpdateMutation($routePlanId: ID, $routePlanIds: [ID!], $input: [LCRRoutePlanUpdateInput!]!) {
  LCRRoutePlanUpdate(routePlanId: $routePlanId, routePlanIds: $routePlanIds, input: $input) {
    id,
    message
    status
  }
}
`
